import Jobs from '@/api/jobs'

export default {
  namespaced: true,
  state: {
    jobs: [],
    jobsLoading: false,
    myBoardJobs: [],
    myBoardJobsLoading: false,
    searchJob: ''
  },
  mutations: {
    setSearchJob (state, searchJob) {
      state.searchJob = searchJob
    },
    setJobs (state, jobs) {
      state.jobs = jobs
    },
    addJob (state, job) {
      state.jobs.unshift(job)
    },
    updateJob (state, job) {
      const index = state.jobs.findIndex(j => j.id === job.id)
      if (index === -1) { return state.jobs.push(job) }
      state.jobs[index] = job
    },
    removeJob (state, jobId) {
      state.jobs = state.jobs.filter(j => j.id !== jobId)
    },
    setJobsLoading (state, jobsLoading) {
      state.jobsLoading = jobsLoading
    },
    setMyBoardJobs (state, myBoardJobs) {
      state.myBoardJobs = myBoardJobs
    },
    setMyBoardJobsLoading (state, myBoardJobsLoading) {
      state.myBoardJobsLoading = myBoardJobsLoading
    }
  },
  actions: {
    async getAllJobs ({ commit }) {
      commit('setJobsLoading', true)
      const jobs = await Jobs.all()
      commit('setJobs', jobs)
      commit('setJobsLoading', false)
    },
    async getMyBoardJobs ({commit}) {
      try {
        commit('setMyBoardJobsLoading', true)
        const jobs = await Jobs.getMyBoardJobs()
        commit('setMyBoardJobs', jobs)
        commit('setMyBoardJobsLoading', false)
      } catch (e) {
        commit('setMyBoardJobsLoading', false)
        console.log('error', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin-jobs.js